<template lang="pug">
  .colorwonder-expectations
    .swatch-section.row.xs-mb-400m
      .cw-swatch-desktop-nav(v-if="!mobileVersion")
        .nav-wrap
          .scroll-up.ripple-btn.cw-color-11(@click="onScrollBtnClick('up')" tabindex="0" role="button" aria-label="Scroll up")
            mr-icon(name="arrow-up").hv-center
          .slider-bar.ui-color-5-bg
            .slider-indicator.ui-color-1-bg.h-center(:style="{ top: `${scrollTopVal}%` }")
          .scroll-down.ripple-btn.cw-color-11(@click="onScrollBtnClick('down')" tabindex="0" role="button" aria-label="Scroll down")
            mr-icon(name="arrow-down").hv-center

      #swatch-selector-desktop(v-if="!mobileVersion")
        .cw-swatch-container
          .cw-swatch-wrap(v-for="swatch in swatches" :key="swatch.displayColorHex+swatch.displayName")
            .cw-swatch.ripple-btn(@click="selectSwatch(swatch)" @keyup.enter="onSwatchEnter(swatch)" :style="{ 'background-color': swatch.displayColorHex }" tabindex="0" role="button" :aria-pressed="selectedSwatch.displayName === swatch.displayName")
              .swatch-name.xs-f-xmedium.max-at-tweak.bold.text-center.ui-color-1.reduce-letter-spacing {{ swatch.displayName }}

              .selected-arrow.ui-color-1.v-center(:class="{'cw-selected': swatch.displayName === selectedSwatch.displayName}")
                mr-icon(name="arrow-right").hv-center

            .cw-swatch-extension
              .extension(:class="{ extended: selectedSwatch.displayName === swatch.displayName }" :style="{ 'background-color': swatch.displayColorHex }")

      #swatch-selector-mobile(v-if="mobileVersion")
        .cw-swatch-container-mobile(v-if="swatches.length > 0")
          slick.the-carousel(ref="mobileSwatchSlider" v-bind="mobileSliderOptions")
            .cw-swatch-wrap-mobile(v-for="swatch in swatches" :key="swatch.displayColorHex+swatch.displayName" ref="mobileSlide" :data-swatch-name="swatch.displayName")
              .cw-swatch-mobile(:style="{ 'background-color': swatch.displayColorHex }" tabindex="0" role="button" :aria-pressed="selectedSwatch.displayName === swatch.displayName")
                .swatch-name.xs-f-medium.sm-medium.max-at-tweak.bold.text-center.ui-color-1.reduce-letter-spacing {{ swatch.displayName }}

          button.left-nav.btn-reset.ripple-btn.text-right.clickable(type="button" @click="mobilePrev")
            .arrow-wrap.cw-color-11
              mr-icon(name="arrow-left").hv-center
              span.ada-tooltip previous

          button.right-nav.btn-reset.ripple-btn.text-left.clickable(type="button" @click="mobileNext")
            .arrow-wrap.cw-color-11
              mr-icon(name="arrow-right").hv-center
              span.ada-tooltip next

      .swatch-results.ui-color-1-bg
        .results-header.ui-color-3-bg
          .rh-left.bold.reduce-letter-spacing.cw-color-11 Starting Shade
          .rh-center
            .arrow-wrap.cw-color-11
              mr-icon(name="arrow-right").hv-center

          .rh-right.bold.reduce-letter-spacing.cw-color-11 Your Results

        .results-container
          .shade-row
            .shade-label.bold.v-center.reduce-letter-spacing.cw-color-11 Light
            .shade-before
              .shade-wrap
                RoundShade(v-if="selectedSwatch && selectedSwatch.lightShadeBefore" :media-obj="selectedSwatch.lightShadeBefore")
            .shade-after
              .shade-wrap
                RoundShade(v-if="selectedSwatch && selectedSwatch.lightShadeAfter" :media-obj="selectedSwatch.lightShadeAfter")
            .row-center.hv-center.cw-color-11
              .arrow-wrap
                mr-icon(name="arrow-right").hv-center

          .shade-row
            .shade-label.bold.v-center.reduce-letter-spacing.cw-color-11 Medium
            .shade-before
              .shade-wrap
                RoundShade(v-if="selectedSwatch && selectedSwatch.mediumShadeBefore" :media-obj="selectedSwatch.mediumShadeBefore")
            .shade-after
              .shade-wrap
                RoundShade(v-if="selectedSwatch && selectedSwatch.mediumShadeAfter" :media-obj="selectedSwatch.mediumShadeAfter")
            .row-center.hv-center.cw-color-11
              .arrow-wrap
                mr-icon(name="arrow-right").hv-center

          .shade-row
            .shade-label.bold.v-center.reduce-letter-spacing.cw-color-11 Dark
            .shade-before
              .shade-wrap
                RoundShade(v-if="selectedSwatch && selectedSwatch.darkShadeBefore" :media-obj="selectedSwatch.darkShadeBefore")
            .shade-after
              .shade-wrap
                RoundShade(v-if="selectedSwatch && selectedSwatch.darkShadeAfter" :media-obj="selectedSwatch.darkShadeAfter")
            .row-center.hv-center.cw-color-11
              .arrow-wrap
                mr-icon(name="arrow-right").hv-center


</template>

<script>
  import RoundShade from "@components/ColorwonderExpectations/RoundShade";
  import dataToolSvc from "@services/dataToolSvc";
  import { scrollBy } from "seamless-scroll-polyfill";
  import { mapState } from "vuex";

  const MIN_TOP_VAL = 4;
  const MAX_TOP_VAL = 71;
  export default {
    name: "ColorwonderExpectations",
    components: { RoundShade },

    data() {
      return {
        swatches: [],
        selectedSwatch: {},
        scrollTopVal: 0,
        mobileSliderOptions: {
          centerMode: true,
          slidesToShow: 1,
          dots: false,
          arrows: false,
          responsive: [
            {
              breakpoint: 761,
              settings: {
                arrows: false,
                centerMode: true,
                centerPadding: '40px',
                slidesToShow: 1
              }
            },
            {
              breakpoint: 480,
              settings: {
                arrows: false,
                centerMode: true,
                centerPadding: '30px',
                slidesToShow: 1
              }
            }
          ],
        }
      };
    },

    props: {
      trackClickEvent: {
        type: String,
        default: "ColorWonder Landing - Expectation setting module clicked"
      },
    },

    computed: {
      ...mapState('global', ['windowData']),

      ...mapState('subscriptions', [
        'cancelFlowPauseModalCancelReasons'
      ]),

      mobileVersion() {
        return ['mobile', 'tablet'].includes(this.windowData.breakpoint);
      },

      selectedSwatchIndex() {
        return this.swatches.findIndex(swatch => swatch.displayName === this.selectedSwatch.displayName);
      },
    },

    mounted() {
      this.scrollTopVal = MIN_TOP_VAL;
      dataToolSvc.getData({
        mixinKey: 'colorwonder_expectations'
      }).then(res => {
        this.swatches = res.data?.swatches || [];
        this.selectedSwatch = this.swatches[0];
      }).catch(() => {
        this.swatches = [];
        this.selectedSwatch = {};
      });

    },

    methods: {
      mobileNext() {
        this.$refs.mobileSwatchSlider.next();
        this.mobileFindActiveSwatch();
      },

      mobilePrev() {
        this.$refs.mobileSwatchSlider.prev();
        this.mobileFindActiveSwatch();
      },

      mobileFindActiveSwatch() {
        setTimeout(() => {
          let slickSlide = this.$refs.mobileSwatchSlider.$el.querySelector('.slick-active');
          let slickSlideSwatchName = slickSlide.querySelectorAll("[data-swatch-name]")[0].dataset.swatchName;
          this.selectSwatch(this.swatches.find(swatch => swatch.displayName === slickSlideSwatchName));
        }, 200); // delay to ensure slick has updated the classes on the slides
      },

      selectSwatch(swatchObj) {
        this.trackMREvent(this.trackClickEvent, { swatch: swatchObj.displayName });
        this.selectedSwatch = swatchObj;
      },

      onSwatchEnter(swatch) {
        this.selectSwatch(swatch);
      },

      increaseSwatchIndex() {
        if (this.selectedSwatchIndex === this.swatches.length - 1) {
          return;
        }

        this.selectSwatch(this.swatches[this.selectedSwatchIndex + 1]);
      },

      decreaseSwatchIndex() {
        if (this.selectedSwatchIndex === 0) {
          return;
        }

        this.selectSwatch(this.swatches[this.selectedSwatchIndex - 1]);
      },

      adjustScrollIndicator(compensate) {
        let totalScrollRange = MAX_TOP_VAL - MIN_TOP_VAL;
        let scrollBarUnit = totalScrollRange / 100;

        const scrollEl = document.getElementById('swatch-selector-desktop');
        let clientHeight = scrollEl.clientHeight;
        let scrollElUnit = 100 / (scrollEl.scrollHeight - clientHeight);

        let scrollPercentage = (scrollEl.scrollTop + compensate) * scrollElUnit;

        // determine the scroll bar position
        let newLocation = Math.round(scrollPercentage) * scrollBarUnit;
        if (newLocation < MIN_TOP_VAL) {
          newLocation = MIN_TOP_VAL;
        } else if (newLocation > MAX_TOP_VAL) {
          newLocation = MAX_TOP_VAL;
        }
        this.scrollTopVal = newLocation;
      },

      onScrollBtnClick(direction) {
        const scrollEl = document.getElementById('swatch-selector-desktop');
        let scrollOptions = { top: 0, behavior: 'smooth' };

        let scrollAmount = scrollEl.scrollHeight / this.swatches.length;

        if (direction === 'up') {
          this.decreaseSwatchIndex();
          scrollAmount = -scrollAmount;
        } else {
          this.increaseSwatchIndex();
        }

        scrollOptions.top = scrollAmount;
        scrollBy(scrollEl, scrollOptions);
        this.adjustScrollIndicator(scrollAmount);
      }
    }
  };
</script>


<style scoped lang="stylus">
  .colorwonder-expectations
    .reduce-letter-spacing
      letter-spacing -1px

    .arrow-wrap
      height 2em
      width 2em
      background-color ui-color-1
      border-radius 50%

    .swatch-section
      max-width 920px
      display flex
      flex-direction column

      .swatch-results
        border-radius 10px
        padding 1em

        .results-header
          display flex
          justify-content space-between
          align-items center
          padding 0.7em
          border-radius 10px

          .rh-left
          .rh-right
            flex 6
            text-align center

          .rh-center
            flex 1
            text-align center

        .arrow-wrap
          position relative
          margin auto
          border 2px solid ui-color-4

        .results-container
          display flex
          flex-direction column
          margin-top 1.5em

          .shade-row
            display flex
            flex-direction row
            position relative

            .shade-label
              position absolute
              left 0
              writing-mode tb-rl
              transform rotate(-180deg) translate(0%, 50%)

            .row-center
              position absolute

              .arrow-wrap
                height 2.5em
                width 2.5em

            .shade-before
              border-right 1px solid ui-color-4

            .shade-before
            .shade-after
              flex-grow 1

              .shade-wrap
                width 60%
                margin 0.75em auto

      #swatch-selector-mobile
        .cw-swatch-container-mobile
          max-width 36em
          margin auto
          position relative

        .cw-swatch-wrap-mobile
          height 85px
          position relative

          .cw-swatch-mobile
            border-radius 10px
            padding 1em 0.5em
            position absolute
            top 50%
            left 50%
            width 90%
            transform translate(-50%, -50%)
            cursor pointer
            //max-width 20em
            margin auto
            transition all 0.4s ease-in-out

        :deep(.slick-slider)
          margin-bottom 10px

        .the-carousel
          :deep(.slick-track)
            .slick-slide
              transition transform 0.4s ease-in-out

            .slick-current
              .cw-swatch-wrap-mobile
                .cw-swatch-mobile
                  padding 1.6em 0.5em
                  transition all 0.4s ease-in-out

        .left-nav
        .right-nav
          position absolute
          top 50%
          transform translateY(-50%)

          .arrow-wrap
            height 2.7em
            width 2.7em

        .left-nav
          left 8%

        .right-nav
          right 8%

    @media mq-mobile
      .swatch-results
        margin-right 0.5em
        margin-left 0.5em

    @media mq-tablet
      .swatch-results
        margin-right 1em
        margin-left 1em

    @media mq-desktop-md
      .swatch-section
        .cw-swatch-desktop-nav
          width 3em

    @media mq-desktop-md-plus
      .swatch-section
        flex-direction row
        column-gap 10px
        max-height 40em
        overflow hidden

        .cw-swatch-desktop-nav
          width 5em

          .nav-wrap
            margin-top 12em
            width 3em
            display flex
            flex-direction column

            .scroll-up
            .scroll-down
              height 2.5em
              width 2.5em
              padding 1.5em
              margin auto
              position relative
              background-color ui-color-1
              border-radius 50%
              box-shadow 0px 4px 3px #f2f0f0
              cursor pointer

            .slider-bar
              height 5em
              margin 0.6em auto
              width 0.8em
              border-radius 1em
              position relative

              .slider-indicator
                height 1.3em
                width 0.6em
                position relative
                border-radius 1em
                transition all 0.3s ease-in-out

        #swatch-selector-desktop
          width 38%
          overflow-y hidden
          overflow-x hidden

          .cw-swatch-wrap
            display flex
            margin-bottom 0.5em

            .cw-swatch
              border-radius 10px
              padding 1.5em 0.5em
              width 89%
              position relative
              cursor pointer

            .selected-arrow
              position absolute
              right 0
              width 2em
              height 2em
              background-color alpha(#fff, 0.2)
              border-radius 50%
              opacity 0
              transition all 0.4s ease-in-out

              &.cw-selected
                opacity 1
                right -1em

            .cw-swatch-extension
              width 10%

              .extension
                width 3em
                height 100%
                margin-left -3em
                border-bottom-right-radius 10px
                border-top-right-radius 10px
                transition all 0.5s ease-in-out

                &.extended
                  margin-left -1em
                  transition all 0.4s ease-in-out

        .swatch-results
          width 62%

</style>
